import React from 'react';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import { RouteProp } from '@react-navigation/native';
import ProfileHeaderContainer from '../../../../v2BaseComponents/ProfileHeaderContainer';
import ReportsList from './ReportsList';

export type ReportsScreenOwnProps = {};

export type ReportsScreenProps = ReportsScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'reports'>;
};

const ReportsScreen: React.FC<ReportsScreenProps> = (props) => {
    return (
        <ProfileHeaderContainer profileId={props.route.params.profileId} bottomBorder>
            <ReportsList profileId={props.route.params.profileId} />
        </ProfileHeaderContainer>
    );
};

export default React.memo(ReportsScreen);
